import FooterMenu from './MenuFooter'

export default FooterMenu
